













































































































































































































































































































































import {
  addStudent,
  addMobileRelation,
  addStudentHeader,
} from "@/api/studentManage";
import avatarCliper from "@/components/avatarCliper.vue";
import avatarUploader from "@/components/avatarUploader.vue";
import { staffList, getSeleSubjectsList } from "@/api/globalSearch";
import { getUserInfo } from "@/api/staff";
import { phonePass, guardianPhonePass } from "@/utils/rules";
import { Vue, Prop, Component } from "vue-property-decorator";
import { PageModule } from "@/store/module/page";
import selectRegionPhoneNumber from "@/components/selectRegionPhoneNumber.vue";
import { getAge } from "@/utils/timeFormat";
import { getMarketStaffListApi } from "@/api/marketActivity";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";

@Component({
  name: "latentStudentAddDialog",
  components: {
    avatarUploader,
    selectRegionPhoneNumber,
    avatarCliper,
  },
})
export default class extends Vue {
  @Prop() studentId!: number;
  guardianMaxNum: number = 11;
  maxNum: number = 11;
  mySreaCodePhone = {
    // 自己的手机区号
    checked: true,
    code: "86",
    code_id: 1,
    en_name: "China",
    name: "中国大陆",
  };
  guardianSreaCodePhone = {
    // 监护人手机区号
    checked: true,
    code: "86",
    code_id: 1,
    en_name: "China",
    name: "中国大陆",
  };
  form: any = {
    avatar: "",
    avatar_url: "",
    name: "",
    mobile: "",
    wechat: "",
    mobile_relation: 0,
    guardian_relation: 0,
    status: 1,
    // source_type: 1,
    follow_staff_id: "",
    join_potential: "",
    recruit_staff: "",
    age: 0,
  };
  staffid = "";
  dialogVisible: boolean = false;
  relationList: any[] = [];
  staffList: any[] = [];
  subjectList: any[] = [];
  sourceList: any[] = [];
  avatarList: any[] = [];
  market_staff_list: any[] = [];
  ageMonth = 0;
  rules = {
    name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
    mobile: [
      { required: true, message: "请输入手机号", trigger: "blur" },
      { validator: phonePass, trigger: "blur" },
    ],
    // guardian_mobile: [{ required: true, validator: guardianPhonePass, trigger: "blur" }],
    appear_id: [
      { required: true, message: "请选择学员出现方式", trigger: "change" },
    ],
    source_type: [
      { required: true, message: "请选择学员来源渠道", trigger: "change" },
    ],
  };
  pickerOptions = {
    disabledDate(time: any) {
      return time.getTime() > Date.now() - 24 * 3600 * 1000;
    },
  };
  loading: boolean = false;
  studentAppearLabelList: any[] = [];
  dateChoose(e: any) {
    const _t = this as any;
    if (e < -2147483648 * 1000) {
      _t.$message({
        type: "error",
        message: "出生日期超出可选范围!",
      });
      _t.form.birthday = 0;
      _t.form.age = 0;
      _t.ageMonth = 0;
      return;
    }
    if (e != null) {
      const age = getAge(e);
      _t.form.age = age[0];
      _t.ageMonth = age[1];
    } else {
      _t.form.age = 0;
      _t.ageMonth = 0;
    }
  }
  openDialog() {
    getUserInfo().then((res: any) => {
      if (res.error_code === 0) {
        this.staffid = res.data.staff_id;
      }
    });
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
      status: 1,
    }).then((res) => {
      this.studentAppearLabelList = res.data.list;
    });
    this.mySreaCodePhone.code = "86";
    this.guardianSreaCodePhone.code = "86";
    this.guardianMaxNum = 11;
    this.maxNum = 11;
    this.dialogVisible = true;
    this.form = {
      avatar: "",
      name: "",
      mobile: "",
      mobile_relation: 0,
      guardian_relation: 0,
      status: 1,
      age: 0,
      source_type: "",
      join_potential: "",
      follow_staff_id: "",
    };
    this.ageMonth = 0;
    this.sourceList = [];
    if (this.relationList.length === 0) {
      addMobileRelation().then((res: any) => {
        this.relationList = res.data.list;
        this.form.mobile_relation = res.data.list[0].key;
        this.form.guardian_relation = res.data.list[1].key;
      });
    } else {
      this.form.mobile_relation = this.relationList[0].key;
      this.form.guardian_relation = this.relationList[1].key;
    }
    if (this.staffList.length === 0) {
      staffList({
        page: 1,
        page_size: 500,
        job_ids: [3],
        status: 1,
      }).then((res: any) => {
        this.staffList = res.data.list;
      });
    }
    if (this.subjectList.length === 0) {
      getSeleSubjectsList({
        page: 1,
        page_size: 500,
        status: 1,
      }).then((res: any) => {
        this.subjectList = res.data.list;
      });
    }
    // 随机头像
    if (this.avatarList.length === 0) {
      addStudentHeader().then((res: any) => {
        this.avatarList = res.data.list;
        const ran = Math.floor(Math.random() * res.data.list.length);
        this.form.avatar = res.data.list[ran].avatar;
        this.form.avatar_url = res.data.list[ran].avatar_url;
      });
    } else {
      const ran = Math.floor(Math.random() * this.avatarList.length);
      this.form.avatar = this.avatarList[ran].avatar;
      this.form.avatar_url = this.avatarList[ran].avatar_url;
    }
  }
  // 获取市场顾问列表
  getMarketStaffListApiFn(v?: any) {
    getMarketStaffListApi({
      page: 1,
      page_size: 100,
      keyword: v,
      status: 1,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.market_staff_list = res.data.list;
      }
    });
  }
  // 模糊搜索 - 市场顾问
  handleSearchMarketStaff(v: any) {
    this.getMarketStaffListApiFn(v);
  }
  // 市场顾问列表下拉
  handleMarketStaffVisible(rest: any) {
    if (rest) {
      this.getMarketStaffListApiFn();
    }
  }
  handleClose() {
    this.dialogVisible = false;
  }
  handleFaceImageChange(key: string) {
    // 用户照片更新
    this.form.avatar = key;
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          if (this.loading) {
            return false;
          }
          const option = { ...this.form };
          delete option.avatar_url;
          if (option.join_potential) {
            option.join_potential = option.join_potential === 2;
            if (option.join_potential === 2 || !option.follow_staff_id) {
              delete option.follow_staff_id;
            }
          } else {
            delete option.join_potential;
            delete option.follow_staff_id;
          }
          if (this.mySreaCodePhone.code) {
            option.area_code = this.mySreaCodePhone.code;
          }
          if (this.guardianSreaCodePhone.code) {
            option.guardian_area_code = this.guardianSreaCodePhone.code;
          }
          if (option.birthday) {
            option.age =
              new Date().getFullYear() -
              new Date(option.birthday).getFullYear();
            option.birthday = new Date(option.birthday).getTime() / 1000;
          }
          if (this.form.market_staff_id) {
            option.market_staff_id = Number(this.form.market_staff_id);
          }
          this.loading = true;
          option.ignore_exist_mobile = false;
          addStudent(option)
            .then((res: any) => {
              if (res.error_code === 0) {
                setTimeout(() => {
                  this.loading = false;
                }, 1000);
                this.$message({
                  type: "success",
                  message: "添加成功",
                });
                this.handleClose();
                this.$emit("change");
              } else if (res.error_code === 21009011) {
                this.$confirm(
                  "录入学员的手机号已存在，确认是否继续录入",
                  "新增意向学员-手机号已存在",
                  {
                    confirmButtonText: "继续录入",
                    confirmButtonClass: "mwow-button-filled success mini",
                    cancelButtonText: "暂不录入",
                    cancelButtonClass: "mwow-button-filled mini",
                    iconClass: "mwow-icon-error",
                  }
                )
                  .then(() => {
                    option.ignore_exist_mobile = true;
                    addStudent(option).then((res: any) => {
                      if (res.error_code === 0) {
                        setTimeout(() => {
                          this.loading = false;
                        }, 1000);
                        this.$message({
                          type: "success",
                          message: "添加成功",
                        });
                        this.handleClose();
                        this.$emit("change");
                      }
                    });
                  })
                  .catch(() => {
                    setTimeout(() => {
                      this.loading = false;
                    }, 100);
                  });
              } else if (res.error_code === 21009004) {
                this.$confirm(
                  `姓名与历史学员冲突，确定提交后将修改历史学员姓名，并随机生成后缀，例如：${this.form.name}_asd0asdf`,
                  `学员信息重复 - ${this.form.name}`,
                  {
                    confirmButtonText: "继续录入",
                    confirmButtonClass: "mwow-button-filled success mini",
                    cancelButtonText: "暂不录入",
                    cancelButtonClass: "mwow-button-filled mini",
                    iconClass: "mwow-icon-error",
                  }
                )
                  .then(() => {
                    option.force = 1;
                    addStudent(option).then((res: any) => {
                      if (res.error_code === 0) {
                        setTimeout(() => {
                          this.loading = false;
                        }, 1000);
                        this.$message({
                          type: "success",
                          message: "添加成功",
                        });
                        this.handleClose();
                        this.$emit("change");
                      }
                    });
                  })
                  .catch(() => {
                    setTimeout(() => {
                      this.loading = false;
                    }, 100);
                  });
              } else {
                this.$message({
                  type: "error",
                  message: "添加失败!" + res.message,
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      }
    );
  }
  areaCode(data: any) {
    PageModule.SET_PAGE_INFO({
      name: "areaCodePhoneNumber",
      key: "area_code",
      value: data[0].code,
    });
    if (data) {
      this.mySreaCodePhone = data[0];
      if (
        data[0].code !== "86" &&
        data[0].code !== "852" &&
        data[0].code !== "853" &&
        data[0].code !== "886"
      ) {
        this.maxNum = 16;
        return;
      } else if (data[0].code === "852" || data[0].code === "853") {
        this.maxNum = 8;
        return;
      } else if (data[0].code === "886") {
        this.maxNum = 10;
        return;
      } else {
        this.maxNum = 11;
        return;
      }
    }
  }
  guardianAreaCode(data: any) {
    PageModule.SET_PAGE_INFO({
      name: "guardianAreaCodePhoneNumber",
      key: "area_code",
      value: data[0].code,
    });
    if (data) {
      this.guardianSreaCodePhone = data[0];
      if (
        data[0].code !== "86" &&
        data[0].code !== "852" &&
        data[0].code !== "853" &&
        data[0].code !== "886"
      ) {
        this.guardianMaxNum = 16;
        return;
      } else if (data[0].code === "852" || data[0].code === "853") {
        this.guardianMaxNum = 8;
        return;
      } else if (data[0].code === "886") {
        this.guardianMaxNum = 10;
        return;
      } else {
        this.guardianMaxNum = 11;
        return;
      }
    }
  }
  // 优化出现方式
  handleChangeAppear() {
    if (!this.form.appear_id) {
      return false;
    }
    sourceTypeSelectListApi({ appear_id: this.form.appear_id, status: 1 }).then(
      (res: any) => {
        this.sourceList = res.data.list;
      }
    );
    this.form.source_type = "";
    this.sourceList = [];
  }
  beforeDestroy() {
    PageModule.SET_PAGE_INFO({
      name: "areaCodePhoneNumber",
      key: "area_code",
      value: "",
    });
    PageModule.SET_PAGE_INFO({
      name: "guardianAreaCodePhoneNumber",
      key: "area_code",
      value: "",
    });
  }
}
